import { useLocalStorage } from 'react-use';
import styled from 'styled-components';

import { Translate, useFormController } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { patientPhoneNotificationTranslationKeys } from '../../translations';
import { PurchasePackageModalButton } from '../common/PurchasePackageModal/PurchasePackageModalButton';

import { StyledPatientPhoneNotificationHeader } from './PatientPhoneNotificationHeader';
import { PatientPhoneNotificationPackageTable } from './PatientPhoneNotificationPackageTable';

const SHOW_INACTIVE_PACKAGES_PREFERENCE_KEY = 'SHOW_INACTIVE_PACKAGES_PREFERENCE_KEY';

const StyledControlsSection = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 8px;
`;
StyledControlsSection.displayName = 'StyledControlsSection';

export const PatientPhoneNotificationPackageSection = (): JSX.Element => {
   const [showInactivePackagesPreference, setShowInactivePackagesPreference] = useLocalStorage<boolean>(
      SHOW_INACTIVE_PACKAGES_PREFERENCE_KEY,
      false
   );
   const controller = useFormController({ showInactive: showInactivePackagesPreference });

   return (
      <div>
         <StyledPatientPhoneNotificationHeader>
            <Translate>{patientPhoneNotificationTranslationKeys.smsPackages}</Translate>
         </StyledPatientPhoneNotificationHeader>
         <StyledControlsSection>
            <PurchasePackageModalButton
               label={patientPhoneNotificationTranslationKeys.purchaseSmsPackageButtonLabel}
               modalTitle={patientPhoneNotificationTranslationKeys.purchaseSmsPackageTitle}
            />
            <Checkbox
               controller={controller.register('showInactive')}
               label={patientPhoneNotificationTranslationKeys.showInactive}
               testId={'showInactiveCheckbox'}
               onSelectionChange={setShowInactivePackagesPreference}
            />
         </StyledControlsSection>
         <PatientPhoneNotificationPackageTable showInactivePackagesPreference={showInactivePackagesPreference} />
      </div>
   );
};
